import gallery from '../../components/galleryPage/scripts/gallery';

/**
 * inject gallery angular module in the storyApp. The gallery angular module has to be visible when the storyApp is initialized
 */
angular.module('storyApp', ['ngRoute', 'gallery']).config(['$routeProvider', '$locationProvider','$anchorScrollProvider',function($routeProvider, $locationProvider,$anchorScrollProvider) {

    $routeProvider
        //all routes except root will be directed to RouteCtrl
	    .when('/:morepath*', {
	        template: '',
	        controller: 'RouteCtrl'
	    })
        .otherwise({
            redirectTo: '/'
        })

    $locationProvider.html5Mode({
        enabled: true,
        requireBase: false,
        rewriteLinks: false
    });
    
    $anchorScrollProvider.disableAutoScrolling();

}]);




// WEBPACK FOOTER //
// ./assets/components/threethings/storyApp.js